import { Observable } from 'rxjs'
import AxiosSubscriber from '../../factory/AxiosSubscriber'
import {
  requestAccessToken,
  requestTokenSourceType,
} from '../../shared/requestAccessToken'

export class AddTopicAnnotationAPI {
  constructor() {
    this.subscription = null
  }

  subscribe(
    token,
    orderId,
    attachmentId,
    versionId,
    data,
    next,
    complete,
    error
  ) {
    requestAccessToken(requestTokenSourceType.GUEST_ANNOTATION, (csrfToken) => {
      const httpConfig = {
        url: `/g/guest/order/${orderId}/attachment/${attachmentId}/version/${versionId}/annotation`,
        method: 'post',
        data: data,
        headers: {
          'x-csrf': csrfToken,
          accept: 'application/json',
          'Content-Type': `application/json`,
          Authorization: `Bearer ${token}`,
        },
      }

      let observable$ = new Observable((observer) => {
        return new AxiosSubscriber(observer, httpConfig, false)
      })

      this.subscription = observable$.subscribe({
        next: next,
        complete: complete,
        error: error,
      })
    })
  }

  unsubscribe() {
    if (this.subscription !== undefined && this.subscription !== null) {
      this.subscription.unsubscribe()
    }
  }
}
